import { useState, useEffect, Fragment } from "react";
import { useTranslation } from "react-i18next";

import useAppSelector from "hooks/useAppSelector";
import { getPublishablePicture } from "utilities/PictureStatusFilter";
import PrimaryActionButton from "components/__reusable/PrimaryActionButton";
import PublishPicturePromptDialog from "./PublishPicturePromptDialog";

const PublishButton = () => {
  const { t } = useTranslation();
  const { pictures } = useAppSelector((state) => state.picture);
  const [isDisablePublish, setIsDisablePublish] = useState(false);
  const [isPublishButtonClick, setIsPublishButtonClick] = useState(false);

  useEffect(() => {
    if (pictures.length === 0) setIsDisablePublish(true);
    const publishablePicture = getPublishablePicture(pictures);
    setIsDisablePublish(publishablePicture.length === 0);
  }, [pictures]);

  return (
    <Fragment>
      <PrimaryActionButton
        label={
          <Fragment>
            <span>{t("_unpublished_picture_class._confirm")}</span>
            <span className="invisible">hh</span>→
          </Fragment>
        }
        disabled={isDisablePublish}
        onClick={() => setIsPublishButtonClick(true)}
      />
      {isPublishButtonClick && (
        <PublishPicturePromptDialog
          onClose={() => setIsPublishButtonClick(false)}
        />
      )}
    </Fragment>
  );
};

export default PublishButton;
